

export default {
    name: 'JdRefereeList',
    props: {
        referees: Array,
    },
    computed: {
        hasReferees() {
            return this.referees && this.referees.length > 0
        }
    },
}
